import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";

import { HrnsToken } from "../../models/auth/hrns-token";

const TOKEN_KEY = "token";
export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);
export const removeAuthToken = () => localStorage.removeItem(TOKEN_KEY);

interface ITokenData {
  tokenData: HrnsToken | null;
  error: string;
}

const useDecodedToken = (): ITokenData => {
  const [tokenData, setTokenData] = useState<ITokenData>({
    tokenData: null,
    error: "",
  });

  const token = getAuthToken();

  const getTokenData = (token: string) => {
    try {
      setTokenData((state) => ({
        ...state,
        tokenData: jwtDecode<HrnsToken>(token),
      }));
    } catch (error: any) {
      setTokenData((state) => ({ ...state, error: error?.message ?? error }));
    }
  };

  useEffect(() => {
    if (token) getTokenData(token);
  }, [token]);

  return tokenData;
};

export default useDecodedToken;
